import React, { useContext, useMemo } from "react";
import { CarinaContext } from "../../CarinaProvider";
export var useTransitions = function(param) {
    var format = param.format, isRtl = param.isRtl;
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    return useMemo(function() {
        if (prefersReducedMotion) {
            return 'fade';
        }
        if (format === 's' || format === 'm' || format === 'l' || format === 'fullscreen') {
            return [
                'fade',
                {
                    appear: {
                        transform: 'scale(0.5)'
                    },
                    appearing: {
                        transform: 'scale(1)'
                    },
                    enter: {
                        transform: 'scale(0.5)'
                    },
                    entering: {
                        transform: 'scale(1)'
                    },
                    exited: {
                        transform: 'scale(0.5)'
                    },
                    transitionProperty: 'transform'
                }
            ];
        }
        if (format === 'bottom') {
            return [
                'fade',
                'slide-up'
            ];
        }
        if (format === 'end' && !isRtl || format === 'start' && isRtl) {
            return [
                'fade',
                'slide-left'
            ];
        }
        return [
            'fade',
            'slide-right'
        ];
    }, [
        format,
        isRtl,
        prefersReducedMotion
    ]);
};
export default useTransitions;
